<template>
    <div class="topbar">
        <div class="container flex">
            <div class="welcome">
                <transition-group class="group" name="list" tag="div" enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutUp">
                    <p v-show="idx == gong_gao_index" v-for="(val,idx) in gong_gao" v-bind:key="idx + 'group'">{{val}}</p>
                </transition-group>
            </div>
            <!-- <div class="user">
                <template v-if="token">
                    <a>{{account}}</a>
                    <span>|</span>
                    <a href="javascript:;" class="exit" @click="exit()">退出</a> 
                </template>
                <template v-else>
                    <a href="javascript:;" @click="loginReg('login')">登录</a>
                    <span>|</span>
                    <a href="javascript:;" @click="loginReg('reg')">注册</a> 
                </template>
            </div> -->
        </div>

        <el-dialog
            title=""
            :visible.sync="login_reg_visible"
            :append-to-body="true"
            custom-class="dialog-login_reg"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="455px">
            <loginReg ref="loginReg" :showType="login_reg_type"></loginReg>
        </el-dialog>
        <audio id="kaijiang-audio" src="../../assets/images/kaijiang.mp3"></audio>      
    </div>
</template>

<script>    
    import loginReg from '@/components/common/loginReg.vue'
    import { getConfig } from '@/api/config.js';
    import { mapGetters, mapActions } from 'vuex';
    export default {
        components: {
            loginReg
        },
        data() {
            return {
                login_reg_visible: false,
                login_reg_type: "",
                default_loty: {
                    loty: "",
                    name: ""
                },
                gong_gao: [],
                gong_gao_index: 0,
                config: {}
            };
        },
        created() {
            this.$eventBus.$on('showLoginReg',(res)=>{
                this.login_reg_visible = true;
                this.login_reg_type = res;                
            });
            this.$eventBus.$on('hideLoginReg',(res)=>{
                this.login_reg_visible = false;
            });
            this.initData();
        },
        beforeDestroy() {
            //移除监听
            this.$eventBus.$off('showLoginReg');
            this.$eventBus.$off('hideLoginReg');
        },
        computed: {
            ...mapGetters(['token','account','lottery_config'])
        },
        watch:{
            lottery_config:{
                handler: function(val){
                    if (val && val.length > 0) {
                        this.default_loty = this.lottery_config[0].list[0];                        
                    }
                }
            }
        },
        methods: {
            ...mapActions(['getLotteryList','logOut','getUserinfo']),
            initData() {
                this.getConfig();
                this.getLotteryList();
                this.getUserinfo();
            },
            getConfig() {
                getConfig().then((response)=>{
                    this.config = response.data.data;
                    this.isMobile();
                    this.gong_gao = this.config.gong_gao;
                    this.autoPlay();
                })
            },
            loginReg(type) {                
                this.$eventBus.$emit('showLoginReg',type);
            },
            exit() {
                this.$confirm('确定退出吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message.success('成功');
                    this.logOut();
                }).catch(() => {
                    ;          
                });
                
            },
            autoPlay () {
                if(this.gong_gao) {
                    let length = this.gong_gao.length;
                    if (this.gong_gao_index >= length) {
                        this.gong_gao_index = 0;
                        this.autoPlay();
                    } else {
                        setTimeout(()=>{
                            this.gong_gao_index++;
                            this.autoPlay();
                        }, 4000)
                    }
                }
            },
            isMobile() {
                if (this.config.h5_url && navigator.userAgent.match(/(iPhone|iPod|Android|ios|SymbianOS)/i)) {
                    location.href = this.config.h5_url;
                }
            }
        }
    }
</script>

<style lang="scss">
.topbar {
    width: 100%;
    height: 40px;
    line-height: 1;
    background: #f1665d;
    clear: both;
    color: #ffffff;
    background: linear-gradient(#B67F3C, #815524);
    font-size: 14px;
    .container {
        justify-content: space-between;
    }
    .welcome {
        line-height: 40px;
        .group {
            height: 40px;
            overflow: hidden;
        }
    }
    .user {
        display: flex;
        align-items: center;
        text-align: right;
        a {
            color: #ffffff;
        }
        span {
            padding: 0 10px;
        }
    }
    .content { 
        width: 70px;
        height: 30px;
        box-sizing: border-box; 
        padding: 1px; 
        border-radius: 5px;  
        background-image: linear-gradient(top, #FFFF8C 0%, #FFFF8C 30%, #DEA54F 60%, #DEA54F 90%);  
        line-height: 28px;
        text-align: center;
    }
    .box { 
        width:100%; 
        height:100%; 
        border-radius:5px; 
        background: linear-gradient(#DEA54F, #744122 52%, #935C24);
        display: block;
    }
}
.el-dialog.dialog-login_reg {
    width: 455px;
    background: transparent;
    .el-dialog__header {
        display: none;
    }
    .el-dialog__body {
        padding: 0;
    }
}
.animated{-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both}
@keyframes fadeInUp{0%{opacity:0;-webkit-transform:translateY(20px);transform:translateY(20px)}100%{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes fadeInUp{0%{opacity:0;-webkit-transform:translateY(20px);-ms-transform:translateY(20px);transform:translateY(20px)}100%{opacity:1;-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0)}}.fadeInUp{-webkit-animation-name:fadeInUp;animation-name:fadeInUp}
@keyframes fadeOutUp{0%{opacity:1;-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0)}100%{opacity:0;-webkit-transform:translateY(-20px);-ms-transform:translateY(-20px);transform:translateY(-20px)}}.fadeOutUp{-webkit-animation-name:fadeOutUp;animation-name:fadeOutUp}
</style>



// WEBPACK FOOTER //
// src/components/common/topbar.vue